import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SERVICE_DETAIL_BANNERS } from '../service-detail-banners';
import { ServiceOrbitVisualComponent } from '../shared/service-orbit-visual/service-orbit-visual.component';


@Component({
  selector: 'app-digital-media-center',
  standalone: true,
  imports: [CommonModule, RouterLink, ServiceOrbitVisualComponent],
  templateUrl: './digital-media-center.component.html',
  styleUrl: './digital-media-center.component.scss',
  host: {
    '[style.--service-banner-image]': 'serviceBannerImage',
  },
})
export class DigitalMediaCenterComponent {
  readonly serviceBannerImage = SERVICE_DETAIL_BANNERS.digitalMediaCenter;
}
